<template>
    <div>
        <div v-if="modalVisible" class="modal fade show" tabindex="1050">
            <div class="modal-dialog modal-lg" style="max-width: 80%" role="document">
                <div class="modal-content">
                    <template v-if="modalState === 'new'">
                        <new-client mode="modalMode" @cancel="hideModal" @saved="clientSaved">
                        </new-client>
                    </template>
                    <template v-if="modalState === 'select'">
                        <client-select mode="modalMode" @cancel="hideModal" @select="clientSelected">
                        </client-select>
                    </template>
                    <template v-if="modalState === 'edit'">
                        <edit-client mode="modalMode" :clientId="worksheet.client.id" @cancel="hideModal" @saved="clientSelected">
                        </edit-client>
                    </template>
                </div>
            </div>
        </div>
        <div class="card mb-2">
            <div class="card-header">
                <div class="collapsed card-link" data-parent="#accordion">
                    <div class="float-left align-bottom">Megrendelő*</div>
                    <div class="float-right text-sm-right">
                        <button type="submit" class="btn btn-sm btn-primary" @click.prevent="selectClient"
                            :disabled="disabled"
                        >
                            Kiválsztás
                        </button>
                        <button type="submit" class="btn btn-sm btn-primary" @click.prevent="editClient"
                            :disabled="!isClientSelected || disabled"
                        >
                            Módosítás
                        </button>
                        <button type="submit" class="btn btn-sm btn-primary" @click.prevent="newClient"
                                :disabled="disabled"
                        >
                            Új ügyfél
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group" stlye="inline-block">
                            <label for="client-name">Megrendelő neve</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="client-name"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="worksheet.client.name"
                                    disabled
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group" stlye="inline-block">
                            <label for="client-address">Megrendelő címe</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="client-address"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="worksheet.client.address"
                                    disabled
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group" stlye="inline-block">
                            <label for="client-phone">Megrendelő telefonszáma</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="client-phone"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="worksheet.client.phone"
                                    disabled
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group" stlye="inline-block">
                            <label for="client-mail">Megrendelő e-mail címe</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="client-mail"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="worksheet.client.email"
                                    disabled
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="modalVisible" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
    import NewClient from '../NewClient';
    import ClientSelect from '../ClientSelect';
    import EditClient from '../EditClient';

    export default{
        name: 'ClientData',
        data(){
            return {
                modalVisible: false,
                modalState: 'none'
            }
        },
        props: {
            worksheet: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isClientSelected(){
                return this.worksheet.client.id !== null && this.worksheet.client.id !== undefined;
            }
        },
        methods: {
            newClient(){
                this.modalState = 'new';
                this.modalVisible = true;
                return false;
            },

            editClient(){
                this.modalState = 'edit';
                this.modalVisible = true;
                return false;
            },

            hideModal(){
                this.modalVisible = false;
                this.modalState = 'none';
            },

            clientSaved(id){
                this.worksheet.client.id = id;
                this.loadClient();
            },
            selectClient(){
                this.modalState = 'select';
                this.modalVisible = true;
                return false;
            },

            clientSelected(id){
                this.worksheet.client.id = id;
                this.loadClient();
                this.modalVisible = false;
            },

            loadClient(){
                let id = this.worksheet.client.id;
                this.$store.dispatch(
                    'ClientModul/getClient',
                    {
                        id,
                        result: res => {
                            let data = res.data;
                            this.worksheet.client = data.client;
                        }
                    }
                );
            },
        },
        components: {
            NewClient,
            ClientSelect,
            EditClient
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/worksheet/ClientData.vue